import { getMessage } from '../i18n/messages.js';
/**
 * Normalizes account-recovery return targets to same-origin relative paths.
 *
 * External, absolute, protocol-relative, backslash-normalized, `/login*`, and
 * `/signup*` candidates silently collapse to `/` so callers can embed the
 * result without reopening auth-loop or open-redirect paths.
 */
export function sanitizeAccountReturnTo(candidate) {
    if (!candidate?.startsWith('/')) {
        return '/';
    }
    // Some browsers normalize backslashes to forward slashes, so `/\evil.com`
    // can resolve to a protocol-relative `//evil.com` open redirect. Normalize
    // first, then reject protocol-relative prefixes and any embedded scheme.
    const normalized = candidate.replace(/\\/g, '/');
    if (normalized.startsWith('//') ||
        normalized.includes(':') ||
        normalized.startsWith('/login') ||
        normalized.startsWith('/signup')) {
        return '/';
    }
    return normalized;
}
export function buildAccountRecoveryHref(path, email, returnTo) {
    const params = new URLSearchParams();
    const trimmedEmail = email.trim();
    if (trimmedEmail) {
        params.set('email', trimmedEmail);
    }
    params.set('returnTo', sanitizeAccountReturnTo(returnTo));
    return `${path}?${params.toString()}`;
}
export function buildExistingIdentityServerError(email, returnTo) {
    return {
        code: 'confirm-existing-identity',
        title: getMessage('en-US', 'existingIdentityConfirmTitle'),
        message: getMessage('en-US', 'existingIdentityConfirmation'),
        recoveryActions: [
            {
                href: buildAccountRecoveryHref('/login', email, returnTo),
                label: getMessage('en-US', 'existingIdentityConfirm'),
            },
            {
                href: buildAccountRecoveryHref('/forgot-password', email, returnTo),
                label: getMessage('en-US', 'emailAlreadyExistsResetPassword'),
            },
        ],
    };
}
//# sourceMappingURL=accountRecovery.js.map